import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { catalogBibShape, ugcCommentShape, paginationShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import {
  selectComments,
  selectCurrentUserComments,
  selectCommentsPagination,
  selectCommentsTransactions
} from 'app/selectors/ugc/CommentsSelector';
import { selectUserIdsForComments } from 'app/selectors/RelationshipsSelector';
import CommentsActions from 'app/actions/CommentsActions';
import RelationshipsActions from 'app/actions/RelationshipsActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import AllCommentsPage from './AllCommentsPage';

export function AllCommentsPageContainer(props) {
  const { catalogBib, intl } = props;
  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'all_comments_page_title' }, { title });

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <AllCommentsPage {...props} />
    </div>
  );
}

AllCommentsPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  comments: ImmutablePropTypes.listOf(ugcCommentShape).isRequired,
  currentUserComments: ImmutablePropTypes.mapOf(ugcCommentShape).isRequired,
  currentUserId: PropTypes.number,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  pagination: paginationShape.isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isFetching: PropTypes.bool,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  userIds: ImmutablePropTypes.listOf(PropTypes.number).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  comments: selectComments(state),
  currentUserComments: selectCurrentUserComments(state),
  currentUserId: selectCurrentUser(state)?.get('id') ?? null,
  commentsTransactions: selectCommentsTransactions(state),
  pagination: selectCommentsPagination(state),
  isFetching: state.getIn(['ugc', 'comments', 'isFetching'], false),
  userIds: selectUserIdsForComments(state)
});

const mapDispatchToProps = dispatch => ({
  commentsActions: bindActionCreators(CommentsActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch),
  relationshipsActions: bindActionCreators(RelationshipsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AllCommentsPageContainer));
